import { Outlet } from "react-router-dom";
import Header from "./Common/Header";
import { Toolbar } from "@mui/material";


export default function Layout({ username, setUsername }) {
  return (
    <>
      <Header username={username} />
      <Toolbar />
      <Outlet context={{ setUsername }} />
    </>
  );
}
